module.exports = __webpack_public_path__ + "assets/img/thumb-Discover-Massage-Video.aaaf98ee.jpg";